import USW from "../Entries/Education/USW";

export default function Education() {
  return (
    <div>
      <USW />
    </div>
  );
}